import { AccountSummary } from '../../models/crm/types';

/** Payload of `accountsCompleted` - the reference ids of the usable accounts and the response rows. */
export type AccountsCompletedPayload = {
  referenceIds: string[];
  accounts: AccountSummary[];
}

/**
 * Excluding enroll calls - for example:
 *  - getIndividualExtendedInfo
 */

export enum CRMCall {
  getIndividualExtendedInfo,
  getCountryList,
  getAccounts,
  getTradingPlatforms,
  updateIndividualTransitionFromNewToForVerification,
  searchTradingPlans,
  searchPlanDetails,
  createPlanPayment,
  createPurchasePayment,
  activateDemoAccount,
  clientSettingsTradingPlan,
  modifyOwnBirthdate,
  couponPreview,
  getReferralOwnProfile,
  getReferralOwnQr,
  getReferralOwnReferredUsers,
  getReferralOwnCommissions,
  createReferralOwnPayoutRequest,
}

export enum LegalDeclarations {
  ClientAgreement = 'Client Agreement',
  GeneralTerms = 'General Terms and Conditions',
  PrivacyPolicy = 'Privacy Policy',
}

export type UploadDocumentFiles = {
  file_name: string,
  file_data: string,
}
